export class LandingCorporation {
    constructor(
        public id: string,
        public name: string
    ) {}
}
